import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnDestroy, OnInit } from "@angular/core";
import { HTMLService } from "@services/htmlService.service";
import { fromEvent, Subscription } from "rxjs";
import { debounceTime, tap, throttleTime } from "rxjs/operators";
import "./scroll-shadow.directive.scss";

@Directive({
    selector: "[scrollShadow]"
})
export class ScrollShadowDirective implements OnInit, OnDestroy, AfterViewInit {
    @Input("scrollShadow") direction: "both" | "top" | "bottom" = "both";

    // ---

    private topShadow: HTMLElement;
    private bottomShadow: HTMLElement;

    private showingTopShadow = false;
    private showingBottomShadow = false;

    private subscriptons = new Subscription();

    constructor(
        private el: ElementRef<HTMLElement>,
        private readonly htmlService: HTMLService) {
    }

    ngOnInit() {
        this.subscriptons.add(fromEvent(this.el.nativeElement, 'scroll').pipe(
            throttleTime(10), // emits once, then ignores subsequent emissions for 50ms, repeat...
            tap(event => {
                this.showHideShadows();
                this.addRemoveScrollingClass();
            })
        ).subscribe());
    }

    ngOnDestroy() {
        this.subscriptons.unsubscribe();
    }

    ngAfterViewInit() {

        this.topShadow = this.createShadow("top");
        this.bottomShadow = this.createShadow("bottom");

        this.accountForParentPaddings();
        setTimeout(() => {
            this.showHideShadows();
        });
    }

    // ---

    scrolling = false;
    removeScrollTimeout: number;
    private addRemoveScrollingClass() {
        if (!this.scrolling) {
            this.el.nativeElement.classList.add("scrolling");
            this.scrolling = true;
        }

        if (this.removeScrollTimeout) {
            clearTimeout(this.removeScrollTimeout);
        }

        this.removeScrollTimeout = window.setTimeout(() => {
            this.el.nativeElement.classList.remove("scrolling");
            this.removeScrollTimeout = null;
        });
    }

    private createShadow(position: "top" | "bottom"): HTMLElement {
        const child = document.createElement('div');

        child.className += `scroll-shadow-${position}`;

        if (position == "top") {
            this.el.nativeElement.prepend(child);
        }
        else {
            this.el.nativeElement.appendChild(child);
        }

        return child;
    }

    private showHideShadows() {
        window.performance.mark("scroll-shadow");
        var scrollTop = this.el.nativeElement.scrollTop;
        var scrollHeight = this.el.nativeElement.scrollHeight;

        var scrollBuffer = 25;

        var showShadowClass = "show";

        // Top Shadow
        if (scrollTop > scrollBuffer) {

            if (!this.showingTopShadow) {
                this.topShadow.classList.add(showShadowClass);
                this.showingTopShadow = true;
            }
        }
        else if (this.showingTopShadow) {
            this.topShadow.classList.remove(showShadowClass);
            this.showingTopShadow = false;
        }

        // Bottom Shadow
        if (/*scrollShadowBottom*/true) {
            var clientHeight = this.el.nativeElement.clientHeight;
            if (scrollTop + clientHeight + scrollBuffer < scrollHeight) {
                if (!this.showingBottomShadow) {
                    this.bottomShadow.classList.add(showShadowClass);
                    this.showingBottomShadow = true;
                }
            }
            else if (this.showingBottomShadow) {
                this.bottomShadow.classList.remove(showShadowClass);
                this.showingBottomShadow = false;
            }
        }

        window.performance.measure("scroll-shadow");
    }

    private accountForParentPaddings() {
        var style = window.getComputedStyle(this.el.nativeElement);

        this.topShadow.style.top = `-${style.paddingTop}`;
        this.bottomShadow.style.bottom = `-${style.paddingBottom}`;
    }
}
